import React from 'react';

const DefaultFooter = ({ data }) => {
  return (
    <>
      <footer className="relative bg-red-400 py-8">
        Footer
      </footer>
    </>
  );
};

export default DefaultFooter;